import TranslationDictionaryTrialPlaceholder from '@/shared/assets/images/translation-dictionary-trial.png';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { LimitedFeatureContent, ModalContent } from '../types';

const TRIAL_PLAN_CONTENT: ModalContent = {
  title: 'Fix a term once, never correct it again',
  bulletsHeader: '',
  buttonText: 'See plans with Dictionary',
  content: {
    // Dictionary is a Business-and-up feature (Figma 6161:5361)
    allowedPlanNames: ['Business'],
    chip: {
      title: 'Get consistent translations with Dictionary and other Pro tools',
    },
    perfectFor: {
      title: 'Perfect for',
      text: 'teams and creators with specific terminology or brand language.',
    },
    selectedPlan: 'Business',
    whatYouCanDo: {
      title: 'With Dictionary:',
      bullets: [
        'Your brand voice stays consistent in every language',
        'No more re-editing the same terms across projects',
        'Translations that sound like you, not just correct',
      ],
    },
  },
  features: [],
  media: {
    src: TranslationDictionaryTrialPlaceholder,
    type: 'image',
  },
  mixpanelButtonClickEvent: () => MixpanelEvents.trialFeatureUpsellModalUnlockClick({ feature: 'translationDictionary' }),
  mixpanelOpeningEvent: () => MixpanelEvents.trialFeatureUpsellModalShown({ feature: 'translationDictionary' }),
  subtitle:
    'Dictionary saves your brand names, product terms, and key phrases — and uses them consistently across every project.',
};

export const TRANSLATION_DICTIONARY_CONTENT: LimitedFeatureContent = {
  trial: TRIAL_PLAN_CONTENT,
};
